import { ComposableDeviceForm } from './ComposableDeviceForm';
import { ComposableDeviceForm as FFComposableDeviceForm } from '../../../customized/fours-fringand-fr/components/ComposableDevice/ComposableDeviceForm';
import { ToggleComponent } from '../../../featureToggle';

export default ToggleComponent(ComposableDeviceForm, {
  styledComponentsVariants: {
    'fours-fringand-fr': FFComposableDeviceForm,
  },
});
